import enumOptionsValueForIndex from "./enumOptionsValueForIndex";
import isNil from 'lodash/isNil';
/** Add the enum option value at the `valueIndex` to the list of `selected` values in the proper order as defined by
 * `allEnumOptions`
 *
 * @param valueIndex - The index of the value that should be selected
 * @param selected - The current list of selected values
 * @param [allEnumOptions=[]] - The list of all the known enumOptions
 * @returns - The updated list of selected enum values with enum value at the `valueIndex` added to it
 */

export default function enumOptionsSelectValue(valueIndex, selected) {
  var allEnumOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var value = enumOptionsValueForIndex(valueIndex, allEnumOptions);

  if (!isNil(value)) {
    var index = allEnumOptions.findIndex(function (opt) {
      return value === opt.value;
    });
    var all = allEnumOptions.map(function (_ref) {
      var val = _ref.value;
      return val;
    });
    var updated = selected.slice(0, index).concat(value, selected.slice(index)); // As inserting values at predefined index positions doesn't work with empty
    // arrays, we need to reorder the updated selection to match the initial order

    return updated.sort(function (a, b) {
      return Number(all.indexOf(a) > all.indexOf(b));
    });
  }

  return selected;
}